import React, { useEffect, useState } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import "./tournament-players-unassigned-remove.scss";
import { getRemoveTitle, removeItemForm } from "../../../forms/DeleteForm";
import TournamentTeamPlayerItem from "./tournament-team-player-item";
import { useSelector } from "react-redux";
import {
  removeTournamentPlayer,
  selectTeamsNotifications,
  selectCurrentUnassignedPlayer,
  getUnassignedPlayer, getTournamentUnassignedPlayers, getTournamentRemovedPlayers,
} from "../../../reducers/teamsSlice";
import { useDispatch } from "react-redux";
import {
  useNotificationAction,
  useNotificationBanner,
} from "../../../hooks/notificationHooks";
import {selectCurrentTournament} from "../../../reducers/tournamentSlice";

//Name the component
const TournamentPlayersUnassignedRemove = (props) => {
  const [isValid, setIsValid] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentTournament = useSelector(selectCurrentTournament);
  const currentUnassignedPlayer = useSelector(selectCurrentUnassignedPlayer);
  const notifications = useSelector(selectTeamsNotifications);

  const matchRemove = useMatch(
    "/:tournamentID/teams/unassigned-players/:playerID/remove"
  );

  useEffect(() => {
    if (matchRemove?.params?.playerID && currentUnassignedPlayer?.id !== matchRemove?.params?.playerID) {
      dispatch(getUnassignedPlayer(matchRemove.params.playerID));
    }
  }, [dispatch, matchRemove?.params?.playerID, currentUnassignedPlayer?.id]);

  useNotificationAction("removed", notifications, () => {
    dispatch(getTournamentUnassignedPlayers(matchRemove?.params?.tournamentID));
    dispatch(getTournamentRemovedPlayers(matchRemove?.params?.tournamentID));
    navigate(-1, { replace: true });
  })

  const removePlayer = () => {
    setIsValid(false)
    if (currentUnassignedPlayer?.id) {
      dispatch(removeTournamentPlayer(matchRemove?.params?.playerID));
    }
  };

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Remove",
        isDisabled: !isValid,
        action: removePlayer,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Remove Player`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getRemoveTitle("Remove Player")}
        formSections={removeItemForm(
          `${currentUnassignedPlayer?.name}`,
          <TournamentTeamPlayerItem {...currentUnassignedPlayer} player={currentUnassignedPlayer} tournament={currentTournament} />,
          "remove",
          `Are you sure you want to remove ${currentUnassignedPlayer?.name}? This player will be added to the removed players list.`
        )}
      ></GSForm>
    );
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner]  = useNotificationBanner({notifications})

  return (
    //name the component tag
    <tournament-players-unassigned-remove>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-players-unassigned-remove>
  );
};

//export the new name
export default TournamentPlayersUnassignedRemove;
